"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiStepConnector = void 0;
var palette_1 = require("../../../theme/global/palette");
exports.MuiStepConnector = {
    root: {},
    horizontal: {},
    vertical: {
        padding: '8px 0px',
    },
    line: {
        borderColor: palette_1.palette.grey[400],
    },
};
